"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Region = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let Region = class Region {
    constructor(name, description) {
        this.name = name;
        this.description = description;
    }
};
exports.Region = Region;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Object)
], Region.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'name', type: 'varchar', length: 100 }),
    tslib_1.__metadata("design:type", String)
], Region.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'description', type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Region.prototype, "description", void 0);
exports.Region = Region = tslib_1.__decorate([
    (0, typeorm_1.Entity)('region'),
    tslib_1.__metadata("design:paramtypes", [String, String])
], Region);
